/**
 * DanaVoice - Application Entry Point
 *
 * Main entry file that initializes React and Neon Auth (Stack Auth).
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { StackProvider, StackTheme } from '@stackframe/react';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { stackClientApp } from './stack';
import { App } from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <StackProvider app={stackClientApp}>
          <StackTheme>
            <App />
          </StackTheme>
        </StackProvider>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
);